import { useEffect } from "react";
import MobileStickyCTA from "./MobileStickyCTA";
import ExitIntentModal from "./ExitIntentModal";
import { captureUTM } from "./tracking";

type Props = {
  phone: string;
  bookHref: string;
  accent?: string;
  exitHeadline?: string;
  exitBody?: string;
  exitCtaLabel?: string;
  exitCtaHref?: string;
  hideStickyOnPaths?: string[];
};

/**
 * Global enhancement wrapper. Drop this inside your <BrowserRouter>.
 * Handles: UTM capture, mobile sticky CTA, desktop exit-intent, (extend here).
 */
export default function SiteEnhancements({
  phone,
  bookHref,
  accent = "#f0a500",
  exitHeadline,
  exitBody,
  exitCtaLabel,
  exitCtaHref = bookHref,
  hideStickyOnPaths,
}: Props) {
  useEffect(() => {
    captureUTM();
  }, []);

  return (
    <>
      <MobileStickyCTA
        phone={phone}
        bookHref={bookHref}
        accent={accent}
        hideOnPaths={hideStickyOnPaths}
      />
      <ExitIntentModal
        headline={exitHeadline}
        body={exitBody}
        ctaLabel={exitCtaLabel}
        ctaHref={exitCtaHref}
        accent={accent}
      />
    </>
  );
}
